export default {
  documents(state) {
    return state.documents
  },
  document(state) {
    return state.document
  },
  pagination(state) {
    return state.pagination
  },
  stats(state) {
    return state.stats
  },
  syncStatus(state) {
    return state.syncStatus
  },
}

